export default __webpack_public_path__ + "static/media/loginAdmin.4e85569c.jpg";